import { render, staticRenderFns } from "./AccountForm.vue?vue&type=template&id=8087ecb4&scoped=true&"
import script from "./AccountForm.vue?vue&type=script&lang=ts&"
export * from "./AccountForm.vue?vue&type=script&lang=ts&"
import style0 from "./AccountForm.vue?vue&type=style&index=0&id=8087ecb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8087ecb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
